module.exports = __webpack_public_path__ + "fonts/roboto-regular-webfont.woff2";